class ClubNotFoundException extends Error {
  constructor(message) {
    super(message);
    this.name = 'ClubNotFoundException';
  }
}

export default ClubNotFoundException;
